import { getPartnerSpecificApps } from '@atlassian/mpac-api-client';
import { useTwoStepVerifiedAsync } from '@atlassian/mpac-ui';
import { DateUtils, log } from '@atlassian/mpac-utils';
import { useCallback } from 'react';
const transformPartnerAppsData = partnerApps => {
  const transformedPartnerApps = partnerApps._embedded.addons.map(app => ({
    id: app.id,
    name: app.name,
    key: app.key,
    manageAppUrl: "/manage/apps/".concat(app.id),
    visibility: app.status,
    lastUpdated: app._embedded.lastModified ? DateUtils.ISOFormatHyphenatedDate(new Date(app._embedded.lastModified)) : ''
  }));
  return {
    count: partnerApps.count,
    apps: transformedPartnerApps
  };
};
export const usePartnerApps = (mpacBaseUrl, partnerId, queryParams) => {
  const promiseFn = useCallback(_ => getPartnerSpecificApps(mpacBaseUrl, partnerId, queryParams).then(data => transformPartnerAppsData(data)).catch(_error => _error), [JSON.stringify(queryParams), partnerId]);
  const {
    data,
    error,
    isPending
  } = useTwoStepVerifiedAsync({
    promiseFn
  });
  if (error) {
    log.error('usePartnerApps', "Failed to retrieve Vendor Apps List", {
      error
    });
  }
  return {
    pending: isPending,
    error,
    partnerApps: data
  };
};